<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="尺寸" name="1">
        <template slot="title">
          尺寸
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialog=true"></i>
        </template>
        <div class="content clearFloat">
          <div class="verticallyCenter" >
            <div class="verticallyCenter mr12 flex1">
              <span class="fs14 mr8">宽</span>
              <single-input
                class="input-size"
                placeholder="-"
                :value.sync="originWidth"
                valueType="px"
                :max="pageLayoutW"
                inputSuffixs="px"
                :min="1"
                :showValueType="false"
                :step ="(minGridWidth/2)"
                :reduceStep="(minGridWidth + minGridWidth/2)"
              />
            </div>
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8">高</span>
              <single-input
                class="input-size"
                placeholder="-"
                :value.sync="originHeight"
                valueType.sync="px"
                :max="10000"
                inputSuffixs="px"
                :min="1"
                :showValueType=" false"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog lineHeight32">
      <p class="fs14 tips mb24"><span>尺寸单位：</span>支持px（像素）、百分比、适应内容和充满布局等多种单位方式，根据不同组件属性可以选择不同的尺寸单位。</p>
      <p class="fs14 tips ">例如：</p>
      <p class="fs14 tips"><span>常规组件：</span>可以设置px和百分比单位，px可以设置为组件固有尺寸，不可超出布局大小；百分比单位为所在布局尺寸的等比大小。</p>
      <p class="fs14 tips mb24"><span>自适应组件：</span>除了px和百分比，还可以设置适应内容和充满布局单位，适应内容是指内容有序排列下，根据内容多少决定当前组件的大小，没有固定值，例如“张三”和“张小三”在相同样式设置下，宽度是不同的；充满布局类似百分比设置为100%，但本身也是根据不同的布局显示不同的大小，区别是多个组件之间可以相互影响。</p>
      <p class="fs14 tips ">需要注意：</p>
      <p class="fs14 tips"><span>组件宽度：</span>在内容区中的组件宽度会自适应最合适的宽度，可能出现输入100px，最终生成120px。</p>
      <p class="fs14 tips"><span>自适应单位：</span>如果子组件设置为充满，所在布局则不能设置适应内容。</p>
      <!--      <div class="box">-->
      <!--        <video src="https://mh.chaoxing.com/sv2/assets/video/size.mp4" controls></video>-->
      <!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "grid-options-setting",
  components: {
  },
  props:{
    options:{
      type:Object,
      required: true
    }
  },
  data(){
    return {
      explainDialog: false,
      pageLayoutId: '',
      pageLayoutW:undefined,
      minGridWidth: undefined,
      activeNames: ["1"],
      COLNUM: 48 // 同步栅格划分的份数
    }
  },
  computed:{
    ids() {
      return this.$store.state.states.activeID
    },
    activeGridId() {
      return this.$store.state.states.activeGridId
    },
    grid(){
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      let grid
      for(let i=0;i<pageLayoutList.length;i++){
        const gridLayout = pageLayoutList[i].layout.rows[0].options.gridLayout
        if (!gridLayout) break
        grid = gridLayout.find(grid=>grid.i === this.activeGridId)
        if(grid){
          this.pageLayoutId = `${i}_0`
          const pageIndex =this.pageLayoutId.split("_")[0]
          let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
          let layout = pageLayout.layout.rows[0]
          // 画布上有1px 的border
          let pageWidth = this.request_prefix === 'stage' ? 1920 : 414 -2
          this.pageLayoutW = pageLayout.options.isFullPage ? pageWidth - pageLayout.options.padding[1] - pageLayout.options.padding[3] : this.$store.state[this.request_prefix].page.pageWidth
          const margin = layout.options.waterFlowMargin ? layout.options.waterFlowMargin[0] : 10
          grid.width = this.computedWidth(grid.w,margin)
          break
        }
      }
      return grid
    },
    originWidth: {
      get() {
        if (this.grid) {
          return this.grid.width
        }
      },
      set(newVal) {
          const pageIndex =this.pageLayoutId.split("_")[0]
          let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
          const margin = pageLayout.layout.rows[0].options.waterFlowMargin ? pageLayout.layout.rows[0].options.waterFlowMargin[0] : 10
          let num  = this.computedWidthNum(newVal,this.pageLayoutW,margin)
          let gridLayout =JSON.parse(JSON.stringify(pageLayout.layout.rows[0].options.gridLayout))
          const gridIndex = gridLayout.findIndex(layout=>layout.i === this.grid.i)
          delete gridLayout[gridIndex].width
          gridLayout[gridIndex].w = num
          this.$changeOptionsEV(gridLayout, "gridLayout", false, undefined, {
            pageLayoutId: this.pageLayoutId
          },undefined)
      }
    },
    originHeight: {
      get() {
        return this.grid && this.grid.h
      },
      set(newVal) {
          const pageIndex =this.pageLayoutId.split("_")[0]
          let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
          let gridLayout =JSON.parse(JSON.stringify(pageLayout.layout.rows[0].options.gridLayout))
          const gridIndex = gridLayout.findIndex(layout=>layout.i === this.grid.i)
          delete gridLayout[gridIndex].width
          gridLayout[gridIndex].h = newVal
          this.$changeOptionsEV(gridLayout, "gridLayout", false, undefined, {
            pageLayoutId: this.pageLayoutId
          },undefined)
        }
    },
  },
  methods:{
    computedWidthNum(curWidth,pageLayoutWidth,margin) {
      // 计算栅格的宽度份数
      const colWidth = (this.pageLayoutW + 2*margin- margin * (this.COLNUM + 1)) / this.COLNUM
      let num = (curWidth +margin) / (colWidth+margin)
      return Math.ceil(num)
    },
    computedWidth(w,margin){
      const colWidth = (this.pageLayoutW + 2*margin - margin * (this.COLNUM + 1)) / this.COLNUM
      this.minGridWidth = colWidth + margin
      return Math.round(colWidth * w + Math.max(0, w - 1) * margin)
    },
  }
}
</script>

<style scoped>

</style>